import React from 'react';
import { useTranslation } from 'react-i18next';

export default React.memo(function Card({ imageSrc, title, newsType, className = '', imgClassName = '' }) {
  const { t } = useTranslation('common');
  return (
    <li
        className={`relative flex-1 w-full h-full flex-col justify-center overflow-hidden rounded-3xl  ${className}`}>
      {imageSrc &&
        <div className={`flex w-full h-full flex-1 items-center justify-center items-stretch ${imgClassName}`}>
          <img src={imageSrc} alt={'preview'} className={'object-fill md:object-cover '} />
        </div>}
      <div id={'card-grid'}
           className={'absolute bottom-0 w-full h-2/5 grid grid-rows p-8 gap-2 justify-items-start bg-gray-300'}>
        <div className={'block py-[10px] px-[15px] bg-white text-base rounded-lg '}>
                    <span className={'block text-black select-none'}>
                      {newsType}
                      {/*{t('buttons.event')}*/}
                    </span>

        </div>
        <div className={'w-full '}>
          <span className={'text-black text-2xl text-clip'}>{title}</span>
        </div>
      </div>
    </li>
  );
});
